/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react';
import { StatusContainer, StatusDot } from './StatusRow.styles';

interface IStatusRow {
	type: string;
	employee: any;
}

const statusLegend: any = {
	scheduled: {
		label: 'Agendado',
		color: '#5082C2',
	},
	canceled: {
		label: 'Rechazado',
		color: '#C22A58',
	},
	nonAvailable: {
		label: 'N/A',
		color: '#D8DEE6',
	},
	finished: {
		label: 'Realizado',
		color: '#8DC63F',
	},
	refer: {
		label: 'Por referir',
		color: '#64778F',
	},
	pending: {
		label: 'Referido',
		color: '#1AB0E6',
	},
	outside: {
		label: 'Fuera de Welbe',
		color: '#5082C2',
	}
};

export const StatusRow = ({ employee, type }: IStatusRow) => {
	const [employeeStatus, setEmployeeStatus] = useState<{[key: string]: string}>({
		color: '',
		label: '',
	});

	const { requireAttention, riskLevel, riskLevelColor, status } = employee

	const handleStatusRow = () => {
		if (!requireAttention && !status) {
			setEmployeeStatus(statusLegend.nonAvailable)
			return
		}

		if (requireAttention && !status) {
			setEmployeeStatus(statusLegend.refer)
			return
		}

		setEmployeeStatus(statusLegend[status] || {
			label: '',
			color: '#fff',
		})
	}

	useEffect(() => {
		const color = riskLevelColor || '#D8DEE6'
		const label = riskLevel || 'N/A'

		type === 'status'
			? handleStatusRow()
			: setEmployeeStatus({ color, label })

		return () => setEmployeeStatus({ color: '', label: '' })
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])


	return (
		<StatusContainer>
			<StatusDot color={employeeStatus.color}/>
			<span>{employeeStatus.label}</span>
		</StatusContainer>
	);
};
